"use client"

import { usePathname } from "next/navigation"
import { useEffect } from "react"

/**
 * Scrolls to the top of the page whenever the pathname changes.
 * Next.js App Router should do this by default, but client-side transitions
 * can sometimes retain scroll position — this component guarantees the reset.
 */
export function ScrollToTop() {
  const pathname = usePathname()

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" })
  }, [pathname])

  return null
}
